import { Component } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { ListaFuncionalidadeComponent } from '../../../shared/components/lista-funcionalidade/lista-funcionalidade.component';

@Component({
  selector: 'app-desenvolvedor-home',
  imports: [MenuComponent, ListaFuncionalidadeComponent],
  templateUrl: './desenvolvedor-home.component.html',
  styleUrl: './desenvolvedor-home.component.css',
})
export class DesenvolvedorHomeComponent {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor() {
    this.moduloEnum = ModuloEnum.Desenvolvedor;
  }
}
